function deepExtend() {
    let object = {};
    let source;
    let property;
    let args = [].splice.call(arguments, 0);

    while (args.length > 0) {
        source = args.splice(0, 1)[0];
        if (toString.call(source) == "[object Object]") {
            for (property in source) {
                if (source.hasOwnProperty(property)) {
                    if (toString.call(source[property]) == "[object Object]") {
                        object[property] = deepExtend(
                            object[property] || {},
                            source[property]
                        );
                    } else {
                        object[property] = source[property];
                    }
                }
            }
        }
    }
    return object;
}

export default deepExtend;
